'use strict';

/**
 * FileHandler
 * @type {{deleteFile: waFileHandler.deleteFile}}
 */
var waFileHandler = {

	/**
	 * Deletes a file from FileStorage
	 *
	 * @param {string} identifier
	 * @param {string} id
	 * @param {array} options
	 */
	deleteFile: function(identifier, id, options) {
		if (identifier === undefined) {
			throw 'waFileHandler::deleteFile() Identifier is not defined';
		}

		if (typeof id === 'object' || id === undefined) {
			if (typeof id === 'object') {
				options = id;
			}
			var url = 'files/delete/' + identifier + '.json';
		} else {
			var url = 'files/delete/' + identifier + '/' + id + '.json';
		}

		let defaultOptions = {
			headers: {
				Accept: 'application/json'
			},
			url: '/' + waApp.getLanguage() + '/' + url,
			type: 'DELETE'
		};

		$.ajax($.extend(defaultOptions, options));
	}
};
